<section class="md-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="md-list-shell">
    <div class="flex align-items-center justify-content-between mb-3">
      <h2 class="m-0">Locations</h2>
    </div>

    <div class="mb-4 p-4 border-round-2xl bg-gray-100">
      <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-map-marker"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="location" id="locationFilter" class="w-full" />
                <label for="locationFilter">Location</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="locationNo" id="locationNoFilter" class="w-full" />
                <label for="locationNoFilter">Location No</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-align-left"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="siteArabicName" id="siteArabicNameFilter" class="w-full" />
                <label for="siteArabicNameFilter">Location Name Arabic</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-home"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="address1" id="address1Filter" class="w-full" />
                <label for="address1Filter">Address</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <app-entity-dropdown-picker formControlName="customer" [adapter]="customerPickerAdapter"
            inputId="customerFilter" label="Customer" placeholder="Select a Customer"
            filterPlaceholder="Filter customers" columnClass="col-12 md:col-8 lg:col-8"
            addonIconClass="pi pi-user"></app-entity-dropdown-picker>


        </div>

        <div class="flex justify-content-end gap-2 mt-4">
          <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary" type="button"
            (onClick)="onReset()"></p-button>
          <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
        </div>
      </form>
    </div>

    <p-table #dt [value]="locations" [rows]="10" [paginator]="true" [totalRecords]="totalRecords"
      (onLazyLoad)="loadLocations($event)" [loading]="isLoading" [lazy]="true" dataKey="id"
      styleClass="p-datatable-striped md-data-table">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="location" style="min-width: 15rem">
            Location <p-sortIcon field="location"></p-sortIcon>
          </th>
          <th pSortableColumn="siteArabicName" style="min-width: 15rem">
            Location Name Arabic <p-sortIcon field="siteArabicName"></p-sortIcon>
          </th>
          <th pSortableColumn="locationNo" style="min-width: 15rem">
            Location No <p-sortIcon field="locationNo"></p-sortIcon>
          </th>
          <th pSortableColumn="address1" style="min-width: 15rem">
            Address <p-sortIcon field="address1"></p-sortIcon>
          </th>
          <th pSortableColumn="customerName" style="min-width: 15rem">
            Customer Name <p-sortIcon field="customerName"></p-sortIcon>
          </th>
          <th pSortableColumn="customerNumber" style="min-width: 15rem">
            Customer Number <p-sortIcon field="customerNumber"></p-sortIcon>
          </th>
          <th style="min-width: 10rem">Actions</th>
        </tr>
      </ng-template>



      <ng-template pTemplate="body" let-location>
        <tr>
          <td>{{ location.location }}</td>
          <td>{{ location.siteArabicName ?? null }}</td>
          <td>{{ location.locationNo ?? null }}</td>
          <td>{{ location.address1 ?? null }}</td>
          <td>{{ location.customer?.customerName ?? null }}</td>
          <td>{{ location.customer?.customerNumber ?? null }}</td>
          <td>
            <div class="flex gap-2">
              <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger"
                (onClick)="deleteLocation(location.id)"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">No Locations found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>